// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconArrowTriangleFullUp = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 6 11' ref={ref} {...props}>
        <path
            fill='currentcolor'
            fillRule='evenodd'
            d='M.126 6.854a.387.387 0 0 0 .606 0L3 4.207l2.268 2.647a.387.387 0 0 0 .606 0 .56.56 0 0 0 0-.708l-2.571-3a.387.387 0 0 0-.606 0l-2.571 3a.56.56 0 0 0 0 .708'
            clipRule='evenodd'
        />
        <g clipPath='url(#icon-arrow-triangle-full-up_svg__a)'>
            <path
                fill='currentcolor'
                d='M2.576 3.196a.56.56 0 0 1 .85 0l2.4 2.666a.72.72 0 0 1 .129.727c-.094.25-.311.413-.555.413L.6 7c-.242 0-.461-.163-.555-.413a.72.72 0 0 1 .13-.727l2.4-2.666z'
            />
        </g>
        <defs>
            <clipPath id='icon-arrow-triangle-full-up_svg__a'>
                <path fill='#fff' d='M0 11h6V.333H0z' />
            </clipPath>
        </defs>
    </svg>
)
const ForwardRef = forwardRef(SvgIconArrowTriangleFullUp)
const Memo = memo(ForwardRef)
export default Memo
